import { RouteProps } from 'react-router';
import { useSelector } from 'react-redux';
import { selectRequestType, selectUser } from '../../store/auth/auth.selector';
import { RequestType } from '../../model/enums/RequestType';
import { Navigate, Outlet } from 'react-router-dom';

type ProtectedRouteProps = {
  canActivate: boolean
}

export default function ProtectedRoute(props: ProtectedRouteProps & RouteProps) {
  const user = useSelector(selectUser);
  const requestType = useSelector(selectRequestType);

  let redirectPath = '/login';
  if (RequestType.isRegistration(user?.requestType)) {
    redirectPath = '/registration';
  } else if (user?.requestType === RequestType.ReceiptOrder) {
    redirectPath = '/receipt';
  }

  if ((user || requestType !== undefined) && props.canActivate) {
    return <Outlet />;
  } else {
    return <Navigate to={redirectPath} />;
  }
};
